import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import * as actions from '../../store/actions/index';
import './Carousel.css';

const Carousel = (props) => {
  const { onCarousel } = props;

  useEffect(() => {
    onCarousel();
  }, [onCarousel]);

  return (
    <div className="bg-green-dark mb-5 rounded carousel">
      <div className="carousel__viewport">
        {props.images.map((item, index) =>
          <div id={`carousel__slide${index + 1}`} className="carousel__slide" key={`img-${index}`}>
            <div className="carousel__snapper"></div>
            <img className="carousel__image" src={item.image} alt={item.alt} width='547' height='512' />
            <p className="carousel__text">{item.text}</p>
          </div>
        )}
      </div>
      <aside className="carousel__navigation">
        <ol className="carousel__navigation-list">
          <li className="carousel__navigation-item">
            <a href="#carousel__slide1"
              className="carousel__navigation-button">Ir a la primera imagen</a>
          </li>
          <li className="carousel__navigation-item">
            <a href="#carousel__slide2"
              className="carousel__navigation-button">Ir a la segunda imagen</a>
          </li>
          <li className="carousel__navigation-item">
            <a href="#carousel__slide3"
              className="carousel__navigation-button">Ir a la tercera imagen</a>
          </li>
        </ol>
      </aside>
    </div>
  )
};

const mapsStateToProps = state => {
  return {
    images: state.images,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onCarousel: () => dispatch(actions.getCarousel())
  }
}

export default connect(mapsStateToProps, mapDispatchToProps)(Carousel);
